<template>
  <div>
    <div class="filterResult"
         @click="close">
      <div class="wrap"
           @click.stop="()=>{}">
        <div class="box">
          <div class="type-title">
            <span>课程分类</span>
          </div>
          <ul class="list">
            <li :class="item.isSelect?'activeTab':''"
                @click="egListTab(item,index)"
                v-for="(item,index) in egList"
                :key="item.egId">{{item.egName}}</li>
          </ul>
        </div>

        <div class="box-bottom">
          <div class="Reset"
               @click="reset()">
            <span>重置</span>
          </div>
          <div class="Sure"
               @click="sure()">
            <span>筛选</span>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>
<script>
import AppSetting from '../../AppSetting';
//   import bus from '../bus/index'
export default {
  data () {
    return {
      egId: 1,
      lId: 1,
      ccId: '',
      egList: [],

    }
  },
  props: {},
  computed: {},
  mounted () {
    this.getEngList()
  },
  methods: {
    egListTab (res, index) {
      let item = res;
      item.isSelect = !item.isSelect

      this.$set(this.egList, index, item)
    },
    close () {
      this.$emit('reset');
    },
    reset () {
      // let param = {}
      this.egId = '';
      this.lId = '';
      this.ccId = '';
      // this.$emit('reset',param)
    },
    sure () {
      let param = {
        egId: this.egId,
        level: this.lId,
        ccId: this.ccId,
      }
      this.$emit('sure', param)
    },
    getEngList () {
      this.$postHttp(AppSetting.baseUrl + '/common/entgroup/info', {}).then((res) => {
        if (res.data.code == 0) {
          let data = res.data.list;
          this.egList = data
          this.egList.map((item) => {
            item.isSelect = false

          })


        }

      })
    },





  },


}
</script>
<style scoped lang="scss">
.filterResult {
  width: 100%;
  height: 100%;
  position: fixed;

  left: 0px;
  top: 0px;
  background: rgba(0, 0, 0, 0.5);
  z-index: 4;
  // position: relative;
  .wrap {
    width: 80%;
    height: 100%;
    background: #fff;
    box-sizing: border-box;
    position: relative;
  }
  .box {
    border-top: 0.01rem solid #eeeeee;
    padding: 0.3rem;
  }
  .wrap div:last-child {
    border-top: none;
    padding: 0rem;
  }
  .type-title {
    font-size: 0.28rem;
    color: #1c1c1c;
  }
  .list {
    font-size: 0.26rem;
    color: #888888;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    li {
      // flex: 1;
      // flex: 1;
      // float: left;
      background: #ededed;
      line-height: 0.415rem;
      padding: 0px 0.2rem;
      border-radius: 1rem;
      margin-right: 0.15rem;
      margin-top: 0.25rem;
    }
    .activeTab {
      background: #087ff8;
      color: #fff;
    }
  }
  .cc-list {
    li {
      font-size: 0.26rem;
      color: #8a959e;
      line-height: 0.95rem;
      border-bottom: 0.01rem solid #eeeeee;
    }
    .activeTab {
      color: #087ff8;
    }
  }
  .box-bottom {
    width: 100%;
    position: absolute;
    bottom: 0px;
    font-size: 0.32rem;
    display: flex;
    text-align: center;
    line-height: 0.8rem;
    height: 0.8rem;
    div:first-child {
      flex: 1;
      background: #dcdcdc;
      color: #535353;
    }
    div:last-child {
      flex: 1;
      background: #087ff8;
      color: #ffffff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/container/filterResult.vue